import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Logic|Approve Logic|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCertApproveLogic';
export type SPCatalogCertApproveLogicLocNames =
	| `${LocNameStart}ButtonApproveLogic`
	| `${LocNameStart}NotificationApproved`
	| `${LocNameStart}NotificationApprovalError`;

export const spCatalogCertApproveLogicLocs: LocDefs<SPCatalogCertApproveLogicLocNames> = {
	SPCatalogCertApproveLogicButtonApproveLogic: {
		defaultValue: 'Approve Logic',
		description: 'Approve Logic button',
		displayPath: `${pathStart}Approve Logic`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCatalogCertApproveLogicNotificationApproved: {
		defaultValue: 'Logic approval successful',
		description: 'Notification saying approval is successful',
		displayPath: `${pathStart}Approval Successful`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPCatalogCertApproveLogicNotificationApprovalError: {
		defaultValue: 'There was an error approving the logic',
		description: 'Notification saying there was an error',
		displayPath: `${pathStart}Approval Error`,
		displayType: 'Notification',
		...sharedProperties,
	},
};

export type SPCatalogCertApproveLogicLocType = LocMap<SPCatalogCertApproveLogicLocNames>;
